/**
 *  All api related to Reviews
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchReviewsByProductID(productId, options = {}) {
  const { page = 1, ...others } = options
  const params = {
    productId,
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchReviewsByProductID',
    () => source.cancel('fetchReviewsByProductID: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'reviews',
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      reviews: _.get(data, 'reviews', {}),
      pagination: data.reviewsPagination,
      next: _.get(data, 'reviewsPagination.nextPage') > page
        ? () =>
          fetchReviewsByProductID(productId, {
            page: page + 1,
            ...others
          })
        : null,
      count: _.get(data, 'reviewsPagination.totalCount')
    }))
}

export function createReview(options) {
  const { data, ...others } = options
  const params = {
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createReview',
    () => source.cancel('createReview: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'reviews',
      method: 'post',
      data: { data },
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      review: data.review
    }))
}
